import React from 'react';
interface CTASectionProps {
  variant?: 'primary' | 'final';
}
export function CTASection({
  variant = 'primary'
}: CTASectionProps) {
  if (variant === 'final') {
    return <div className="my-12 bg-gradient-to-br from-[#1E4D3D] to-[#163a2e] p-8 md:p-12 rounded-xl shadow-2xl text-white" data-id="element-31">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 font-sans" data-id="element-32">
          You Don't Have to Fear the 72-Hour Danger Zone Anymore
        </h2>

        <div className="space-y-4 mb-8 text-white/90 leading-relaxed font-serif" data-id="element-33">
          <p data-id="element-34">
            Right now, you can try Glisera completely risk-free for 60 days.
          </p>

          <p className="font-bold text-white text-xl" data-id="element-35">
            60 days. Not 30. SIXTY.
          </p>

          <p data-id="element-36">
            Why? Because we know your nervous system needs time to heal. And
            we're so confident this will support you through the danger zone
            that we're giving you two full months to feel the difference.
          </p>

          <p data-id="element-37">
            If you experience withdrawal symptoms—if your hands shake—if your
            heart races—if you end up in the ER—send it back. Every penny
            refunded. No questions asked.
          </p>

          <p data-id="element-38">
            You can even use every single patch and still get a full refund if
            you're not satisfied.
          </p>
        </div>

        <div className="bg-white/10 rounded-lg p-6 mb-8" data-id="element-39">
          <h3 className="text-xl font-bold text-white mb-4" data-id="element-40">
            Here's what you're getting today:
          </h3>
          <ul className="space-y-2 text-white/90" data-id="element-41">
            <li data-id="element-42">
              ✓ 30-day supply of Glisera patches (enough to get through the
              danger zone and beyond)
            </li>
            <li data-id="element-43">
              ✓ Discreet, private shipping (no one will know what's inside)
            </li>
            <li data-id="element-44">
              ✓ 24/7 nervous system support during the critical first 72 hours
            </li>
            <li data-id="element-45">
              ✓ No dangerous withdrawal symptoms (the terror that's kept you
              trapped is eliminated)
            </li>
            <li data-id="element-46">✓ 60-day money-back guarantee (zero risk to try)</li>
            <li data-id="element-47">✓ 40% off your first order (today only)</li>
          </ul>
        </div>

        <p className="text-white/90 mb-6 font-serif" data-id="element-48">
          This is less than what you spend on wine each week. And instead of
          another year trapped by fear, you're investing in getting through the
          danger zone safely.
        </p>

        <p className="text-white font-bold mb-8 font-serif" data-id="element-49">
          The 72-hour window you've been terrified of? You can get through it
          without shaking. Without panic attacks. Without ending up in the ER.
        </p>

        <a href="https://thegliserastore.com/products/glissera-anti-alcohol-patch" className="w-full bg-yellow-400 hover:bg-yellow-300 text-gray-900 font-bold py-5 px-8 rounded-lg shadow-lg transition-all hover:scale-[1.02] text-center text-lg uppercase tracking-wide block mb-4" data-id="element-50">
          🔒 YES, I WANT TO TRY GLISERA RISK-FREE (40% OFF)
        </a>

        <p className="text-center text-white/70 text-sm mb-4" data-id="element-51">
          100% Secure Checkout | Made in USA | 60-Day Money-Back Guarantee
        </p>

        <p className="text-center text-yellow-300 font-bold text-sm" data-id="element-52">
          Over 10,000 People Have Made It Through the Danger Zone Safely
        </p>
      </div>;
  }
  return <div className="my-12 bg-gray-50 p-6 md:p-8 rounded-xl border border-gray-200" data-id="element-53">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 font-sans" data-id="element-54">
        Don't Wait Like I Did
      </h2>

      <p className="text-gray-700 mb-4 leading-relaxed font-serif" data-id="element-55">
        I wasted three years stuck in that cycle.
      </p>

      <p className="text-gray-700 mb-4 leading-relaxed font-serif" data-id="element-56">
        Three years of broken promises. Three years of 3 AM shame spirals. Three
        years of watching my daughter pull away from me. Three years of feeling
        like a prisoner in my own body.
      </p>

      <p className="text-gray-700 mb-6 leading-relaxed font-serif" data-id="element-57">
        I can't get that time back.
      </p>

      <p className="text-gray-700 mb-6 leading-relaxed font-serif font-bold" data-id="element-58">
        But you? You can start today.
      </p>

      <p className="text-gray-700 mb-6 leading-relaxed font-serif" data-id="element-59">
        Every morning you wake up with that heavy shame is another morning
        stolen from you.
      </p>

      <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-8" data-id="element-60">
        <p className="text-red-800 text-sm md:text-base font-medium" data-id="element-61">
          <span className="font-bold" data-id="element-62">Limited Time:</span> Due to incredibly
          high demand, supply is limited. New inventory sells out within days.
        </p>
      </div>

      <div className="text-center mb-8" data-id="element-63">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-64">
          What could one month mean for you?
        </h3>
        <ul className="text-left space-y-2 max-w-2xl mx-auto text-gray-700 font-serif" data-id="element-65">
          <li data-id="element-66">✓ Sleeping through the night without 3 AM panic</li>
          <li data-id="element-67">✓ Waking up clear-headed and shame-free</li>
          <li data-id="element-68">✓ Coming home in the evening and feeling genuinely calm</li>
          <li data-id="element-69">✓ Being fully present with your kids</li>
          <li data-id="element-70">✓ Your daughter looking at you again—really looking at you</li>
          <li data-id="element-71">✓ Feeling like yourself for the first time in years</li>
        </ul>
      </div>

      <a href="https://thegliserastore.com/products/glissera-anti-alcohol-patch" className="w-full bg-[#1E4D3D] hover:bg-[#163a2e] text-white font-bold py-4 px-6 rounded shadow-lg transition-transform hover:scale-[1.01] text-center text-sm md:text-base uppercase tracking-wide mb-4 block" data-id="element-72">
        CHECK AVAILABILITY NOW
      </a>

      <p className="text-center text-gray-600 text-sm" data-id="element-73">
        60-Day Money-Back Guarantee — If you don't feel a significant reduction
        in cravings within 60 days, return it for a full refund. No questions
        asked.
      </p>
    </div>;
}